const getDynamicPaths = (rootPath) => ({
  root: rootPath,
  slug: `${rootPath}/[slug]`,
  page: `${rootPath}/[slug]/[page]`,
});

const createPageRoutes = (rootPath, dynamicPaths) => ({
  root: () => ({
    path: rootPath,
    dynamicPath: rootPath,
  }),
  slug: (slug) => ({
    path: `${rootPath}/${slug}`,
    dynamicPath: dynamicPaths.slug,
  }),
  page: (category, page) => ({
    path: `${rootPath}/${category}/${page}`,
    dynamicPath: dynamicPaths.page,
  }),
});

const getPageRoute = (
  category,
  route,
  page = '1',
) => {
  if (category === '') {
    return route.root();
  }

  if (!category || !isNaN(category)) {
    if (+page === 1) return route.root();

    return route.slug(page);
  }

  if (category && +page === 1) {
    return route.slug(category);
  }

  return route.page(category, page);
};

const rootBlogPath = '/blog';
const rootPortfolioPath = '/works';
const rootPersonPath = '/person';
const dynamicBlogPaths = getDynamicPaths(rootBlogPath);
const dynamicPortfolioPaths = getDynamicPaths(rootPortfolioPath);
const dynamicPersonPaths = getDynamicPaths(rootPersonPath);
const blogRoutes = createPageRoutes(rootBlogPath, dynamicBlogPaths);
const portfolioRoutes = createPageRoutes(rootPortfolioPath, dynamicPortfolioPaths);
const personRoutes = createPageRoutes(rootPersonPath, dynamicPersonPaths);

export const routes = {
  fromRoot: (slug) => (slug === 'newhomepage' ? '' : `/${slug}`),
  homepage: {
    title: 'Home',
    path: '/',
    dynamicPath: '/',
    slug: 'newhomepage',
  },
  person: {
    title: 'Person',
    slug: 'person',
    getRoute: (slug, page = '1') => getPageRoute(
      slug,
      personRoutes,
      page,
    ),
    dynamicPath: {
      ...dynamicPersonPaths,
    },
  },
  portfolio: {
    title: 'Our Works',
    breadcrumpsTitle: 'Works',
    path: rootPortfolioPath,
    getRoute: (category, page = '1') => getPageRoute(
      category,
      portfolioRoutes,
      page,
    ),
    dynamicPath: {
      ...dynamicPortfolioPaths,
    },
    slug: 'works',
    categories: [
      {
        title: 'Online Video',
        slug: 'online-video',
      },
      {
        title: 'Real-Time Communication',
        slug: 'real-time-communication',
      },
      {
        title: 'DAM/MAM',
        slug: 'dam-mam',
      },
      {
        title: 'Computer Vision',
        slug: 'computer-vision',
      },
      {
        title: 'Content Management',
        slug: 'content-management',
      },
      {
        title: 'Business Intelligence',
        slug: 'business-intelligence',
      },
      {
        title: 'BPM/BPA',
        slug: 'bpm-bpa',
      },
      {
        title: 'CRM',
        slug: 'crm',
      },
      {
        title: 'eCommerce',
        slug: 'ecommerce',
      },
      {
        title: 'eLearning',
        slug: 'elearning',
      },
      {
        title: 'Adtech/Martech',
        slug: 'adtech-martech',
      },
      {
        title: 'FinTech',
        slug: 'fintech',
      },
      {
        title: 'IoT',
        slug: 'iot',
      },
    ],
  },
  project: {
    title: 'Project',
    getRoute: (slug) => ({
      path: !!slug && `/works/${slug}`,
      dynamicPath: !!slug && '/works/[project]',
    }),
    slug: 'project',
  },
  webinar: {
    title: 'Webinar',
    path: '/webinar/david-vs-goliath',
    dynamicPath: '/david-vs-goliath',
    slug: 'david-vs-goliath',
  },
  webinarAi: {
    title: 'Webinar',
    path: '/webinar/beyond-the-hype',
    dynamicPath: '/beyond-the-hype',
    slug: 'beyond-the-hype',
  },
  webinarLLM: {
    title: 'Webinar',
    path: '/webinar/llm-use-cases-webinar',
    dynamicPath: '/llm-use-cases-webinar',
    slug: 'llm-use-cases-webinar',
  },
  webinarDeployingAgent: {
    title: 'Webinar',
    path: '/webinar/beyond-chatbots-webinar',
    dynamicPath: '/beyond-chatbots-webinar',
    slug: 'beyond-chatbots-webinar',
  },
  process: {
    title: 'Process',
    path: '/process',
    dynamicPath: '/process',
    slug: 'process',
  },
  softwareDevelopmentPrice: {
    title: 'Pricing',
    path: '/pricing',
    dynamicPath: '/pricing',
    slug: 'pricing',
  },
  blog: {
    title: 'Blog',
    slug: 'blog',
    path: rootBlogPath,
    // TODO think a better solution
    getRoute: (category, page = '1') => getPageRoute(
      category,
      blogRoutes,
      page,
    ),
    dynamicPath: {
      ...dynamicBlogPaths,
    },
    categories: [
      {
        title: 'Latest',
        slug: '',
      },
      {
        title: 'AI',
        slug: 'artificial-intelligence',
      },
      {
        title: 'How we work',
        slug: 'how-we-work',
      },
      {
        title: 'Software development',
        slug: 'software-development',
      },
      {
        title: 'Chats',
        slug: 'software-chat',
      },
      {
        title: 'Fintech',
        slug: 'fintech',
      },
      {
        title: 'News',
        slug: 'yellow',
      },
    ],
  },
  search: {
    title: 'Search results',
    slug: 'search',
    path: '/search',
  },
  article: {
    title: 'Article',
    getRoute: (slug) => ({
      path: !!slug && `/blog/${slug}`,
      dynamicPath: !!slug && '/blog/[slug]',
    }),
    slug: 'article',
  },
  company: {
    title: 'Company',
    path: '/company',
    dynamicPath: '/company',
    slug: 'company',
  },
  whyUs: {
    title: 'Why Us',
    path: '/why-us',
    dynamicPath: '/why-us',
    slug: 'why-us',
  },
  contact: {
    title: 'Contact Us',
    path: '/contact',
    dynamicPath: '/contact',
    slug: 'contact',
  },
  services: {
    title: 'Software Development Services for AI & SaaS | Yellow',
    path: '/services',
    dynamicPath: '/services',
    slug: 'services',
  },
  aiEngineeringTransformation: {
    title: 'AI Engineering Transformation Assessment',
    path: '/ai-engineering-transformation/assessment',
    dynamicPath: '/ai-engineering-transformation/assessment',
    slug: 'ai-engineering-transformation/assessment',
  },
  aiSecurity: {
    title: 'AI Security Assessment',
    path: '/ai-security/assessment',
    dynamicPath: '/ai-security/assessment',
    slug: 'ai-security/assessment',
  },
  aiRoi: {
    title: 'AI ROI Assessment',
    path: '/ai-roi/assessment',
    dynamicPath: '/ai-roi/assessment',
    slug: 'ai-roi/assessment',
  },
  aiAgenticOperations: {
    title: 'Agentic Operations Assessment',
    path: '/agentic-operations/assessment',
    dynamicPath: '/agentic-operations/assessment',
    slug: 'agentic-operations/assessment',
  },
  aiProductAcceleration: {
    title: 'AI Product Acceleration Assessment',
    path: '/ai-product-acceleration/assessment',
    dynamicPath: '/ai-product-acceleration/assessment',
    slug: 'ai-product-acceleration/assessment',
  },
  softwareQualityAssuranceServices: {
    title: 'Software Development Price',
    path: '/software-quality-assurance-services',
    dynamicPath: '/software-quality-assurance-services',
    slug: 'software-quality-assurance-services',
  },
  customChatApp: {
    title: 'Custom chat app development company',
    path: '/chat-app-development-company',
    dynamicPath: '/chat-app-development-company',
    slug: 'chat-app-development-company',
  },
  penetrationTesting: {
    title: 'Penetration Testing Services to Secure Your Business',
    path: '/penetration-testing',
    dynamicPath: '/penetration-testing',
    slug: 'penetration-testing',
  },
  customMobileApp: {
    title: 'Custom mobile app development company',
    path: '/mobile-app-development-company',
    dynamicPath: '/mobile-app-development-company',
    slug: 'mobile-app-development-company',
  },
  customWebApp: {
    title: 'Web Application Development Services',
    path: '/web-app-development-company',
    dynamicPath: '/web-app-development-company',
    slug: 'web-app-development-company',
  },
  crowdfundingPlatform: {
    title: 'Crowdfunding Platform Development Company',
    path: '/crowdfunding-platform-development-company',
    dynamicPath: '/crowdfunding-platform-development-company',
    slug: 'crowdfunding-platform-development-company',
  },
  designServices: {
    title: 'UI/UX design services',
    path: '/ui-ux-services',
    dynamicPath: '/ui-ux-services',
    slug: 'ui-ux-services',
  },
  iosDevelopmentServices: {
    title: 'iOS App Development Services',
    path: '/ios-mobile-app-development-services',
    dynamicPath: '/ios-mobile-app-development-services',
    slug: 'ios-mobile-app-development-services',
  },
  androidDevelopmentServices: {
    title: 'Android App Development Services',
    path: '/android-mobile-app-development-services',
    dynamicPath: '/android-mobile-app-development-services',
    slug: 'android-mobile-app-development-services',
  },
  mvpDevelopment: {
    title: 'MVP App Development Services',
    path: '/mvp-app-development-company',
    dynamicPath: '/mvp-app-development-company',
    slug: 'mvp-app-development-company',
    description: 'A minimum viable product will help you get enough feedback to determine whether '
      + 'you should continue a given project. We are ready to help with your MVP development.',
  },
  lendingSoftwareDevelopment: {
    title: 'Lending Software Development Services',
    path: '/lending-software-development',
    dynamicPath: '/lending-software-development',
    slug: 'lending-software-development',
    description: 'Revolutionize lending with our cutting-edge software development solutions for financial institutions.',
  },
  paymentGatewayDevelopment: {
    title: 'Payment Software Gateway Development Company',
    path: '/payment-gateway-development-company',
    dynamicPath: '/payment-gateway-development-company',
    slug: 'payment-gateway-development-company',
    description: 'Yellow is a leading Payment Gateway Development company, providing customized solutions to enhance '
      + 'transaction security and accuracy. Read more about our services now.',
  },
  billingSoftwareDevelopment: {
    title: 'Billing Software Development Services Company',
    path: '/billing-software-development-services',
    dynamicPath: '/billing-software-development-services',
    slug: 'billing-software-development-services',
    description: 'If you want to create brand-new billing software, partner with Yellow and build a top-tier solution.',
  },
  cloudDevelopment: {
    title: 'Cloud Application Development Services',
    path: '/cloud-based-app-development-services',
    dynamicPath: '/cloud-based-app-development-services',
    slug: 'cloud-based-app-development-services',
    description: 'If your application needs a strong cloud backup, Yellow is ready to help you with cloud app development.',
  },
  computerVisionServices: {
    title: 'Computer Vision Services & Solutions',
    path: '/computer-vision-services',
    dynamicPath: '/computer-vision-services',
    slug: 'computer-vision-services',
    description: 'Discover our advanced Computer Vision services and solutions. Custom computer vision software development can transform your business to the next level.',
  },
  aiAgentsServices: {
    title: 'AI agent development services',
    path: '/ai-agent-development-services',
    dynamicPath: '/ai-agent-development-services',
    slug: 'ai-agent-development-services',
    description: 'If you want to build an AI agent for your business, Yellow will help you achieve your goal.',
  },
  naturalLanguageProcessingAsAService: {
    title: 'Natural Language Processing (NLP) Services',
    path: '/natural-language-processing-as-a-service',
    dynamicPath: '/natural-language-processing-as-a-service',
    slug: 'natural-language-processing-as-a-service',
    description: 'Yellow is ready to help you create a natural language processing solution that will boost your business and optimize your processes.',
  },
  roboticProcessAutomationServices: {
    title: 'Robotic Process Automation (RPA) Services',
    path: '/robotic-process-automation-services',
    dynamicPath: '/robotic-process-automation-services',
    slug: 'robotic-process-automation-services',
    description: 'Employ Yellow\'s RPA services to boost efficiency, cut expenses, and empower employees.',
  },
  crossPlatformDevelopmentServices: {
    title: 'Cross-Platform Mobile App Development Company',
    path: '/cross-platform-development-services',
    dynamicPath: '/cross-platform-development-services',
    slug: 'cross-platform-development-services',
  },
  mlDevelopment: {
    title: 'Machine Learning Development Company',
    path: '/machine-learning-development-services',
    dynamicPath: '/machine-learning-development-services',
    slug: 'machine-learning-development-services',
    description: 'If you want to boost your business with custom machine learning software development, Yellow is here to back you up.',
  },
  erpDevelopment: {
    title: 'Custom ERP Software Development Services',
    path: '/enterprise-resource-planning-software-services',
    dynamicPath: '/enterprise-resource-planning-software-services',
    slug: 'enterprise-resource-planning-software-services',
    description: 'Custom ERP software development services will help you achieve flexibility and manage your business more consciously.',
  },
  devOpsDevelopment: {
    title: 'DevOps Development Company that Helps You Grow',
    path: '/devops-development-services',
    dynamicPath: '/devops-development-services',
    slug: 'devops-development-services',
  },
  discoveryPhase: {
    title: 'Project Discovery Phase in Custom Software Development',
    path: '/discovery-phase-services',
    dynamicPath: '/discovery-phase-services',
    slug: 'discovery-phase-services',
    description: 'Discovery phase of a project is an important part of software development. Learn more about how '
      + 'to run a discovery phase and its benefits to your business.',
  },
  signatureGenerator: {
    title: 'Signature Generator',
    path: '/signature-generator',
    dynamicPath: '/signature-generator',
    slug: 'signature-generator',
  },
  fintechDevelopment: {
    title: 'Fintech Software Development Services',
    path: '/fintech-software-development-services',
    dynamicPath: '/fintech-software-development-services',
    slug: 'fintech-software-development-services',
  },
  aiDevelopment: {
    title: 'AI Software Development Services',
    path: '/artificial-intelligence-development-services',
    dynamicPath: '/artificial-intelligence-development-services',
    slug: 'artificial-intelligence-development-services',
    description: 'Yellow is an AI software development company that can provide '
      + 'you with top-notch artificial intelligence application development.',
  },
  dataScienceDevelopment: {
    title: 'Data Science Development Services',
    path: '/data-science-development-company',
    dynamicPath: '/data-science-development-company',
    slug: 'data-science-development-company',
    descripition: 'If you are looking for a partner that will help you analyze, process, and structure '
      + 'your data, data science specialists at Yellow are here for you.',
  },
  tradingSoftwareDevelopment: {
    title: 'Custom Trading Platform Development Services',
    path: '/trading-software-development',
    dynamicPath: '/trading-software-development',
    slug: 'trading-software-development',
    description: 'Proficient trading software development services to create robust apps and platforms that boost business performance.',
  },
  prototypingServices: {
    title: 'Mobile App Prototyping Services',
    path: '/prototyping-services',
    dynamicPath: '/prototyping-services',
    slug: 'prototyping-services',
  },
  privacyPolicy: {
    title: 'Yellow Systems Privacy Policy',
    path: '/privacy-policy',
    dynamicPath: '/privacy-policy',
    slug: 'privacy-policy',
  },
  termsAndConditions: {
    title: 'Terms and Conditions',
    path: '/terms-and-conditions',
    dynamicPath: '/terms-and-conditions',
    slug: 'terms-and-conditions',
  },
  contentRules: {
    title: 'Yellow Editorial Guidelines | Yellow',
    descripition: 'We are following a set of rules and guidelines in regards to the content on our website and related platforms.',
    path: '/editorial-guidelines',
    dynamicPath: '/editorial-guidelines',
    slug: 'editorial-guidelines',
  },
  eWalletAppDevelopment: {
    title: 'E-Wallet App Development Company',
    path: '/e-wallet-app-development',
    dynamicPath: '/e-wallet-app-development',
    slug: 'e-wallet-app-development',
  },
  bankingSoftwareDevelopmentCompany: {
    title: 'Banking Software Development Company',
    path: '/banking-software-development-company',
    dynamicPath: '/banking-software-development-company',
    slug: 'banking-software-development-company',
  },
  deliveryQualityInYellow: {
    title: 'Yellow’s Delivery Quality Standards',
    path: '/delivery-quality-in-yellow',
    dynamicPath: '/delivery-quality-in-yellow',
    slug: 'delivery-quality-in-yellow',
  },
  pwaDevelopmentServices: {
    title: 'PWA Development Services',
    path: '/pwa-development-services',
    dynamicPath: '/pwa-development-services',
    slug: 'pwa-development-services',
  },
  softwareDevelopmentColumbus: {
    title: 'Custom Software Development Company in Columbus, Ohio',
    path: '/software-development-columbus',
    dynamicPath: '/software-development-columbus',
    slug: 'software-development-columbus',
  },
  softwareDevelopmentNashville: {
    title: 'Custom Software Development Company in Nashville, TN',
    path: '/software-development-nashville',
    dynamicPath: '/software-development-nashville',
    slug: 'software-development-nashville',
  },
  softwareDevelopmentOklahoma: {
    title: 'Software Development Company in Oklahoma City',
    path: '/software-development-oklahoma',
    dynamicPath: '/software-development-oklahoma',
    slug: 'software-development-oklahoma',
  },
  softwareDevelopmentRaleigh: {
    title: 'Custom Software Development in Raleigh',
    path: '/software-development-raleigh',
    dynamicPath: '/software-development-raleigh',
    slug: 'software-development-raleigh',
  },
  softwareDevelopmentWashington: {
    title: 'Custom Software Development Company in Washington, D.C.',
    path: '/software-development-washington',
    dynamicPath: '/software-development-washington',
    slug: 'software-development-washington',
  },
  softwareDevelopmentOmaha: {
    title: 'Custom Software Development Services In Omaha',
    path: '/software-development-omaha',
    dynamicPath: '/software-development-omaha',
    slug: 'software-development-omaha',
  },
  softwareDevelopmentMiami: {
    title: 'Custom Software Development Services In Miami',
    path: '/software-development-miami',
    dynamicPath: '/software-development-miami',
    slug: 'software-development-miami',
  },
  softwareDevelopmentMinneapolis: {
    title: 'Custom Software Development In Minneapolis, Minnesota',
    path: '/software-development-minneapolis',
    dynamicPath: '/software-development-minneapolis',
    slug: 'software-development-minneapolis',
  },
  softwareDevelopmentTulsa: {
    title: 'Custom Software Development In Tulsa',
    path: '/software-development-tulsa',
    dynamicPath: '/software-development-tulsa',
    slug: 'software-development-tulsa',
  },
  softwareDevelopmentNewOrleans: {
    title: 'Custom Software Development In New Orleans',
    path: '/software-development-new-orleans',
    dynamicPath: '/software-development-new-orleans',
    slug: 'software-development-new-orleans',
  },
  aiSoftwareDevelopmentServices: {
    title: 'AI Software development services',
    path: '/ai-software-development-services',
    dynamicPath: '/ai-software-development-services',
    slug: 'ai-software-development-services',
  },
  generativeAiDevelopment: {
    title: 'Generative AI Development',
    path: '/generative-ai-services',
    slug: 'generative-ai-services',
  },
  deepLearning: {
    title: 'Deep Learning',
    path: '/deep-learning',
    slug: 'deep-learning',
  },
  aiChatbotDevelopmentServices: {
    title: 'AI Chatbot Development Services',
    path: '/ai-chatbot-development-services',
    slug: 'ai-chatbot-development-services',
  },
  aiStaffAugmentationServices: {
    title: 'AI Staff Augmentation Services',
    path: '/ai-staff-augmentation-services',
    slug: 'ai-staff-augmentation-services',
  },
  aiConsulting: {
    title: 'AI Consulting Services',
    path: '/ai-consulting-services',
    slug: 'ai-consulting-services',
  },
  bookCall: {
    title: '',
    path: '/book-a-call',
    dynamicPath: '/book-a-call',
    slug: 'book-a-call',
  },
  cookiesPolicy: {
    title: 'Cookies Policy',
    path: '/cookies-policy',
    slug: 'cookies-policy',
  },
  notFound: {
    title: '404 | Yellow',
    path: '/not-found',
    dynamicPath: '/not-found',
    slug: 'not-found',
  },
  softwareDevelopmentForStartups: {
    title: 'Software Development Services for Startups: Build Scalable Solutions',
    description: 'We provide custom software development services for startups, offering scalable, affordable, and agile solutions to bring your product to market faster.',
    path: '/software-development-services-for-startups',
    slug: 'software-development-services-for-startups',
  },
  softwareDevelopmentServicesForTechBusinesses: {
    title: 'Comprehensive Software Development Services for Tech Businesses',
    description: 'Discover comprehensive software development services tailored for tech businesses. From custom web and mobile applications to AI solutions and ERP systems, we provide innovative solutions to elevate your business.',
    path: '/software-development-services-for-tech-businesses',
    slug: 'software-development-services-for-tech-businesses',
  },
  softwareDevelopmentServicesForVariousIndustries: {
    title: 'Software Development Services for Various Industries',
    description: 'Discover comprehensive software development services tailored for non-tech businesses. From custom web apps to complex ERP systems, we provide innovative solutions to boost your business.',
    path: '/software-development-services-for-various-industries',
    slug: 'software-development-services-for-various-industries',
  },
  logisticsSoftwareDevelopmentCompany: {
    title: 'Logistics Software Development Company',
    description: 'Enhance your logistics operations with our custom software development services. From inventory management to real-time tracking, we provide tailored solutions that improve efficiency and reduce costs.',
    path: '/logistics-software-development-services',
    slug: 'logistics-software-development-services',
  },
  eCommerceDevelopment: {
    title: 'E-commerce Development Company | Yellow',
    description: 'We offer end-to-end e-commerce software development, including responsive design, mobile optimization, and secure integrations to ensure a seamless online shopping experience.',
    path: '/e-commerce-development',
    slug: 'e-commerce-development',
  },
  travelAndHospitalDevelopment: {
    title: 'Travel Software Development Company | Yellow',
    description: 'Unlock the potential of your educational institution with our custom education software development services. Partner with us to innovate education and drive student success!',
    path: '/travel-and-hospitality-software-development',
    slug: 'travel-and-hospitality-software-development',
  },
  educationalSoftwareDevelopment: {
    title: 'Education Software Development Services | Yellow',
    description: 'Boost your travel and hospitality business with our custom software development services tailored to streamline bookings, enhance guest experiences, and optimize operations. Get started today to stay ahead in a competitive market!',
    path: '/educational-software-development-services',
    slug: 'educational-software-development-services',
  },
  entertainmentSoftwareDevelopment: {
    title: 'Software Development for Media and Entertainment Companies',
    description: 'We create custom, scalable solutions tailored to the needs of media and entertainment businesses. Our technology solutions enhance audience engagement, streamline workflows, and drive revenue growth.',
    path: '/entertainment-software-development-services',
    slug: 'entertainment-software-development-services',
  },
  healthcareDevelopment: {
    title: 'Custom Healthcare Software Development Company',
    description: 'We develop custom healthcare software solutions tailored to your specific needs. Our offerings range from telemedicine platforms and patient management systems to AI-driven diagnostic tools and remote monitoring solutions.',
    path: '/healthcare-software-development-services',
    slug: 'healthcare-software-development-services',
  },
  'software-development-engagement-models': {
    title: 'Flexible Engagement Models for Software Development Projects',
    description: 'Discover tailored engagement models for your software development needs, including outstaffing, project-based, and T&M. Find the perfect solution for your project with flexible pricing options and expert support.\n',
    path: '/software-development-engagement-models',
    slug: 'software-development-engagement-models',
  },
  llmDevelopment: {
    title: 'Large Language Model Development Services',
    description: 'Yellow is here to provide you with custom LLM development services to make sure\n',
    path: '/llm-development-services',
    slug: 'llm-development-services',
  },
  aiVoiceAssistantDevelopment: {
    title: 'AI Voice Assistant Development Company',
    path: '/ai-voice-assistant-development-services',
    dynamicPath: '/ai-voice-assistant-development-services',
    slug: 'ai-voice-assistant-development-services',
    description: 'Discover our expert AI voice assistant development services to create intelligent, human-like copilots that work effortlessly within your business.',
  },
  aiCopilot: {
    title: 'AI Copilot Development Services​ | Copilot Development Solutions​ Company',
    description: 'Find out how AI copilot development services​ can boost your business, strengthen your processes, and bring your team to the next level of productivity.',
    path: '/ai-copilot-development-services',
    slug: 'ai-copilot-development-services',
  },
  ragDevelopment: {
    title: 'RAG Development Services | Yellow',
    description: 'We provide custom RAG development services, including pipeline architecture, agentic RAG, and real-time knowledge augmentation for enterprises that value accuracy, security, and results.',
    path: '/rag-development-services',
    slug: 'rag-development-services',
  },
  mlOpsDevelopment: {
    title: 'MLOps Development Services | AI Deployment & Automation Experts',
    description: 'MLOps development services for businesses looking to deploy, manage, and scale machine learning models. Improve model performance, automate workflows, and maximize AI ROI.',
    path: '/mlops-development-services',
    slug: 'mlops-development-services',
  },
  aiManagedPod: {
    title: 'AI Managed Pods | AI-Native Engineering Teams | Yellow',
    description: 'Scale engineering output without scaling headcount. Yellow AI Managed Pods combine senior engineers with specialized AI agents to build, test, deploy, and operate software faster.',
    path: '/ai-managed-pod',
    slug: 'ai-managed-pod',
  },
};
